import { User } from "@CommonApi/users/list";
import { omniAtom } from "src/utils/atoms";

export const editUserDataAtom = omniAtom({
  key: "modals/editUser",
  value: null as User | null,
});
